import React from "react";
import { Box, Text, Heading, SimpleGrid, Flex, Icon } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { chakra } from "@chakra-ui/react";
import { QuestionOutlineIcon, WarningIcon, ViewIcon,ChevronDownIcon } from "@chakra-ui/icons";

// Chakra-wrapped motion div
const MotionBox = chakra(motion.div);

// Card Animation Variants
const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.25,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};



const ChallengeSection = () => {
  const cards = [
    {
      icon: <QuestionOutlineIcon boxSize={7} color="#2AA198" />,
      title: "Decisions based on gut feeling",
      text: "Without clear market signals, important business decisions become educated guesses that carry unnecessary risk.",
    },
    {
      icon: <WarningIcon boxSize={7} color="#2AA198" />,
      title: "Competitors move faster",
      text: "By the time you notice market shifts, your competitors have already adapted leaving you reactive, not proactive.",
    },
    {
      icon: <ViewIcon boxSize={7} color="#2AA198" />,
      title: "Too many tools, too little clarity",
      text: "Dashboards and data tools promise insights which deliver complexity but making sense of it takes time and efforts.",
    },
  ];

  return (
    <Box w="full" py="28" px="6" bg="#F7F9FC">
      
      {/* Heading */}
      <Box textAlign="center" maxW="3xl" mx="auto">
        <Text
          fontSize="sm"
          letterSpacing="wide"
          color="#315BB3"
          fontWeight="semibold"
          mb="3"
        >
          THE CHALLENGE
        </Text>

        <Heading
          fontSize="5xl"
          fontFamily="serif"
          fontWeight="bold"
          color="#1A2C4E"
          mb="4"
        >
          Sound <Text as="span" color="#2AA198">familiar?</Text>
        </Heading>

        <Text fontSize="lg" color="gray.600">
          Manufacturing leaders face these challenges every day and existing tools aren’t built to help.
        </Text>
      </Box>

      {/* Card Grid */}
      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        spacing="10"
        mt="16"
        maxW="7xl"
        mx="auto"
      >
        {cards.map((card, i) => (
          <MotionBox
            key={i}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={cardVariants}
            bg="white"
            rounded="3xl"
            boxShadow="0px 8px 20px rgba(0,0,0,0.05)"
            p="10"
            border="1px solid #EDF0F4"
            h="full"
          >
            {/* Icon Box */}
            <Flex
              w="16"
              h="16"
              bg="#E8EFF7"
              rounded="2xl"
              align="center"
              justify="center"
              mb="6"
            >
              {card.icon}
            </Flex>

            {/* Title */}
            <Heading
              fontSize="2xl"
              fontFamily="serif"
              fontWeight="bold"
              color="#1A2C4E"
              mb="4"
            >
              {card.title}
            </Heading>

            {/* Text */}
            <Text color="gray.600" fontSize="17px" lineHeight="1.7">
              {card.text}
            </Text>
          </MotionBox>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default ChallengeSection;